module.exports = __webpack_public_path__ + "assets/zclassic.b20ad341.png";